import React, { Component } from 'react';
import './index.scss';
import Layover from '../DetailsPane/ReportOveralay';
import utils from '../../../lib/utils';

class BlockNumber extends Component {
  constructor(props) {
    super(props);
    this.state={
      overlayVisibility:false
    }
  }

  closeOverlay = () =>{
      this.setState({
        overlayVisibility:false
      })
  }

  openOverlay = () =>{
    this.setState({
      overlayVisibility:true
    })
  }
  // selectedConversation={conversations.conversations[0]}
  // auth = {auth}
  // business ={business}
  // erorReport = {this.props.postErrorReport}
  // errorData = {this.props.conversations}
  // clearReportFlags ={this.props.clearReportFlags}

  render(){
  const { overlayVisibility } = this.state;
  const features = utils.getCookie('features');

  return (
    <div className="report">
      <div className="error-report" onClick={this.openOverlay}>
          <div><i className="material-icons">flag</i> <span>Report an issue</span></div>
      </div>
      <Layover 
          setreportOverlayVisibility={this.closeOverlay} 
          modelopen={overlayVisibility} 
          name={''}
          phone={''}
          selectedConversation = {this.props.selectedConversation}
          auth ={this.props.auth}
          business = {this.props.business}
          erorReport ={this.props.erorReport}
          errorData= {this.props.errorData}
          clearReportFlags ={this.props.clearReportFlags}
          globalReport = {true}
          selectedLocation={this.props.selectedLocation}
      />
    </div>
  );
  }
  
};

export default BlockNumber;
